import { Component, OnInit } from '@angular/core';
import { Auth } from '@shared/auth';

@Component({
  selector: 'webapp-compat-navigation',
  template: `
    <app-navigation [transparent]="transparent"></app-navigation>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationComponent implements OnInit {
  transparent: boolean;

  constructor(private auth: Auth) {}

  ngOnInit() {
    // Note: this is a hack for allowing us to set transparent navigation
    // if the PHP template variable transparent_header is set to true.
    this.transparent = (<any>window).webappCompat.navigation.transparent;

    // HACK to force reload the current page when SwitchAccount is used. This
    // is needed of legacy pages as parts of the UI won't react to the
    // AuthState update.
    this.auth.authState.pairwise().subscribe(([previousAuth, auth]) => {
      if (previousAuth && auth && previousAuth.userId !== auth.userId) {
        window.location.reload();
      }
    });
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/compat/compat-navigation.component.ts